import { render, staticRenderFns } from "./NoteMessage.vue?vue&type=template&id=e0e54646"
import script from "./NoteMessage.vue?vue&type=script&lang=js"
export * from "./NoteMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports